module.exports = __webpack_public_path__ + "img/Deltares_logo_D-blauw_RGB.2c1b17f9.png";